module.exports = __webpack_public_path__ + "img/handbag.65c9ec01.svg";